import SagasHelper from "../../helpers/Redux/SagasHelper";
import { takeLatest } from 'redux-saga/effects';
import { APPEALS_ACTIONS } from "./actionTypes";
import { AppealsApi } from "./api";
/**
 * Create appeals
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{countries, type}>|CallEffect|PutEffect<{type}>>}
 */

function* create(action) {
  yield SagasHelper.action(action, AppealsApi.create);
}

export default [takeLatest(APPEALS_ACTIONS.CREATE, create)];